import { Component, OnInit, AfterContentInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { Title } from '@angular/platform-browser';
import { AuthService } from '@auth0/auth0-angular';
import { UsersResource } from '../../core/resources/users.resource';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule, SharedModule]
})
export class CallbackComponent implements OnInit, AfterContentInit {
    public authenticationMessages: string[] = [
        "Convincing the robots you're definitely human...",
        'Cross-checking with the mothership...',
        'Distracting the firewall with cat videos...',
        "Checking if you're on Santa's naughty list...",
        'Teaching passwords proper manners...',
        "Asking the cloud for permission (it's being fluffy)",
        'Counting ones and zeroes in order...',
        'Buffering dad jokes for later...',
        'Baking fresh cookies (the digital kind)',
        'Unsubscribing you from spam... just kidding!',
        'Polishing login buttons to extra shine',
        "Checking if your password is '12345'... nope, carry on!",
        'Rehearsing welcome fanfare',
        'Defusing login drama bombs...',
        'Synchronizing dance moves with servers',
        'Making the hamsters run faster...',
        'Decrypting secrets like a digital James Bond',
        'Consulting the magic 8-ball of access...',
        'Calibrating reality distortion field...',
        "These aren't the droids we're looking for... or are they?",
        'Downloading more RAM for this...',
        'Convincing cookies they want to be eaten (digitally)',
        'Rearranging digital furniture for your arrival',
        "Asking AI if it's still cool with humans",
        'Performing the secret digital handshake'
    ];

    public message: string = '';

    constructor(
        private readonly title: Title,
        private readonly router: Router,
        private readonly auth: AuthService,
        private readonly usersResource: UsersResource
    ) {}

    ngAfterContentInit(): void {
        const randomIndex = Math.floor(Math.random() * this.authenticationMessages.length);
        this.message = this.authenticationMessages[randomIndex];
    }

    ngOnInit(): void {
        this.title.setTitle('Callback | Hive Mind');

        setTimeout(() => {
            this.auth.isAuthenticated$.subscribe((isLoggedIn) => {
                if (isLoggedIn) {
                    this.usersResource.callback().subscribe((result) => {
                        if (!result?.id) {
                            return;
                        }

                        this.router.navigate(['/dashboard']);
                    });
                } else {
                    this.router.navigate(['/access-denied']);
                }
            });
        }, 3000);
    }
}
